* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.wrapper {
  display: block;
  padding-top: calc(2 * var(--spacer));
  padding-left: calc(5 * var(--spacer));
}

.assets-to-scan {
  display: flex;
  flex-direction: column;
}

.assets-to-scan-tab-group {
  flex: auto;
  padding: 2px;

  --tab-header-padding-right: calc(var(--spacer) * 4);
  --tab-body-padding-right: calc(var(--spacer));
  --tab-body-padding-top: 0;
  --tab-body-padding-bottom: 0;
}
